import { Injectable } from '@angular/core';
import { Comune } from '../model/model';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class AssignComuniService {
  constructor() {
  }

  comuni: any = [];

  assignCodComune(descrComune: string) {
    const selectedComune = this.comuni.find((comune: Comune) => comune.descrComune?.trim() === descrComune.trim());
    if (selectedComune) {
      return selectedComune.codComune;
    }
    return '';
  }
}
